<template lang="pug">
	div.card-body
		b
			span.fa.fa-edit.mr-2
			| Intérvalo manual
			.form-group
				label Hora de inicio
				input.form-control.form-control-sm(v-mask="'##:##:##'", v-model="colocacion.HoraInicio", placeholder="HH:MM:SS")
			.form-group
				label Hora de fin
				input.form-control.form-control-sm(v-mask="'##:##:##'", v-model="colocacion.HoraFin", placeholder="HH:MM:SS")
</template>

<script>
export default {
	props: ['colocacion']
}
</script>




// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/colocacion/manual.vue